import { render, staticRenderFns } from "./lisaa-arviointityokalu.vue?vue&type=template&id=9843f8a4&scoped=true&"
import script from "./lisaa-arviointityokalu.vue?vue&type=script&lang=ts&"
export * from "./lisaa-arviointityokalu.vue?vue&type=script&lang=ts&"
import style0 from "./lisaa-arviointityokalu.vue?vue&type=style&index=0&id=9843f8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9843f8a4",
  null
  
)

export default component.exports